(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.dshdReady) return;
      root.dataset.dshdReady = "true";
      var bar = root.querySelector("[data-dshd-bar]");
      var pauseBtn = root.querySelector("[data-dshd-pause]");
      var track = bar && bar.querySelector(".dshd-track");
      if (track) {
        var distance = track.scrollWidth / 2;
        if (distance > 0) track.style.animationDuration = Math.max(40, distance / 28) + "s";
      }
      if (bar && pauseBtn) {
        pauseBtn.addEventListener("click", function () {
          var paused = bar.classList.toggle("is-paused");
          pauseBtn.setAttribute("aria-label", paused ? "Play" : "Pause");
        });
      }
      var drawer = document.querySelector("[data-dshd-drawer]");
      function setDrawer(open) { if (drawer) drawer.hidden = !open; }
      var openBtn = root.querySelector("[data-dshd-open]");
      if (openBtn) openBtn.addEventListener("click", function () { setDrawer(true); });
      document.querySelectorAll("[data-dshd-close]").forEach(function (btn) {
        btn.addEventListener("click", function () { setDrawer(false); });
      });
      var search = document.querySelector("[data-dshd-search]");
      function setSearch(open) {
        if (!search) return;
        search.hidden = !open;
        if (open) {
          var input = search.querySelector("input");
          if (input) input.focus();
        }
      }
      var searchOpen = root.querySelector("[data-dshd-search-open]");
      if (searchOpen) searchOpen.addEventListener("click", function () { setSearch(true); });
      document.querySelectorAll("[data-dshd-search-close]").forEach(function (btn) {
        btn.addEventListener("click", function () { setSearch(false); });
      });
      var count = root.querySelector("[data-dshd-count]");
      var layer = document.querySelector("[data-dshd-cart]");
      var body = document.querySelector("[data-dshd-cartbody]");
      var foot = document.querySelector("[data-dshd-cartfoot]");
      var threshold = layer ? Math.round(parseFloat(layer.getAttribute("data-free-ship") || "0") * 100) : 0;
      var upsellHandles = layer ? (layer.getAttribute("data-upsells") || "").split(",").filter(Boolean) : [];
      var bundleHandle = layer ? (layer.getAttribute("data-bundle") || "") : "";
      var bundleCta = layer ? (layer.getAttribute("data-bundle-cta") || "Upgrade") : "Upgrade";
      var bundleNote = layer ? (layer.getAttribute("data-bundle-note") || "") : "";
      var upsellCache = {};
      var lastCart = null;
      var swapping = false;

      function money(cents, currency) {
        return (cents / 100).toLocaleString("en-US", { style: "currency", currency: currency || "USD" });
      }
      function esc(value) {
        return String(value || "").replace(/[&<>"']/g, function (c) {
          if (c === "&") return "&" + "amp;";
          if (c === "<") return "&" + "lt;";
          if (c === ">") return "&" + "gt;";
          if (c === "\"") return "&" + "quot;";
          return "&" + "#39;";
        });
      }
      function looksLikeBundle(item) {
        var hay = ((item && (item.title || item.product_title) || "") + " " + ((item && item.handle) || "")).toLowerCase();
        return hay.indexOf("bundle") !== -1;
      }
      function isBundleItem(item) {
        if (!item) return false;
        if (bundleHandle && item.handle === bundleHandle) return true;
        return looksLikeBundle(item);
      }
      function cartHasBundle(cart) {
        return (cart.items || []).some(isBundleItem);
      }
      function firstAvailable(product) {
        var variant = null;
        (product.variants || []).forEach(function (v) { if (!variant && v.available) variant = v; });
        return variant || (product.variants || [])[0] || null;
      }
      function offerPrice(product, variant, currency) {
        var price = (variant && variant.price) || 0;
        var compare = (variant && variant.compare_at_price) || 0;
        if (product && isBundleItem(product)) compare = Math.max(compare, 10000);
        var struck = compare > price ? "<s>" + money(compare, currency) + "</s>" : "";
        return '<p class="dshd-upsell-price">' + money(price, currency) + struck + "</p>";
      }
      function setCount(n) {
        if (!count) return;
        count.textContent = n;
        count.hidden = n === 0;
      }
      function setCart(open) {
        if (!layer) return;
        if (open) {
          layer.hidden = false;
          layer.classList.remove("is-open");
          void layer.offsetWidth;
          layer.classList.add("is-open");
          return;
        }
        layer.classList.remove("is-open");
        setTimeout(function () {
          if (!layer.classList.contains("is-open")) layer.hidden = true;
        }, 520);
      }
      function optionLabel(product) {
        var names = (product && product.options) || [];
        var clean = names.map(function (name) {
          return typeof name === "string" ? name : (name && name.name) || "";
        }).filter(function (name) { return name && name !== "Title"; });
        return clean.join(" / ") || "Option";
      }
      function variantControl(item, product) {
        var option = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
        var variants = (product && product.variants) || [];
        if (variants.length < 2) {
          return option ? '<p class="dshd-option">' + esc(option) + "</p>" : "";
        }
        var html = '<div class="dshd-variant-wrap"><label class="dshd-variant-label">' + esc(optionLabel(product)) + '</label><select class="dshd-variant" data-dshd-variant data-key="' + esc(item.key) + '" data-current="' + esc(item.variant_id) + '" aria-label="Change ' + esc(optionLabel(product)) + '">';
        variants.forEach(function (variant) {
          var selected = String(variant.id) === String(item.variant_id) ? " selected" : "";
          var soldOut = !variant.available && String(variant.id) !== String(item.variant_id);
          var label = variant.title && variant.title !== "Default Title" ? variant.title : "Default";
          if (soldOut) label += " — Sold out";
          html += '<option value="' + esc(variant.id) + '"' + selected + (soldOut ? " disabled" : "") + ">" + esc(label) + "</option>";
        });
        html += "</select></div>";
        return html;
      }

      function comparesFor(cart) {
        var handles = [];
        (cart.items || []).forEach(function (item) {
          if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });
        if (!handles.length) return Promise.resolve({ compares: {}, products: {} });
        return Promise.all(handles.map(function (handle) {
          return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
            .then(function (r) { return r.ok ? r.json() : null; })
            .catch(function () { return null; });
        })).then(function (products) {
          var compares = {};
          var byHandle = {};
          products.forEach(function (product) {
            if (!product || !product.variants) return;
            byHandle[product.handle] = product;
            product.variants.forEach(function (variant) {
              compares[variant.id] = variant.compare_at_price || 0;
            });
          });
          return { compares: compares, products: byHandle };
        });
      }

      function render(cart, compares, productsByHandle) {
        if (!body) return;
        compares = compares || {};
        productsByHandle = productsByHandle || {};
        lastCart = cart;
        setCount(cart.item_count || 0);
        var ship = document.querySelector("[data-dshd-ship]");
        var fill = document.querySelector("[data-dshd-shipfill]");
        var shipText = document.querySelector("[data-dshd-shiptext]");
        if (!cart.items || !cart.items.length) {
          if (ship) ship.hidden = true;
          var shopUrl = (layer && layer.getAttribute("data-shop-url")) || "/";
          var shopLabel = (layer && layer.getAttribute("data-shop-label")) || "Shop";
          body.innerHTML = '<p class="dshd-empty">Your bag is empty.</p><div class="dshd-upsell dshd-upsell--empty" data-dshd-upsell-empty></div><a class="dshd-shop" href="' + esc(shopUrl) + '">' + esc(shopLabel) + '</a>';
          if (foot) foot.hidden = true;
          return;
        }
        if (ship) {
          ship.hidden = false;
          if (fill) fill.style.width = "100%";
          if (shipText) shipText.textContent = "You've unlocked free shipping 🥳";
        }
        if (foot) foot.hidden = false;
        var before = 0;
        var lineOff = 0;
        body.innerHTML = cart.items.map(function (item) {
          var img = item.image ? (item.image + (item.image.indexOf("?") === -1 ? "?" : "&") + "width=300") : "";
          var bundle = isBundleItem(item);
          var compareLine = Number(compares[item.variant_id] || 0) * item.quantity;
          if (bundle) compareLine = Math.max(compareLine, 10000 * item.quantity);
          var reference = Math.max(compareLine, item.original_line_price || 0);
          before += reference;
          var struck = reference > item.final_line_price ? "<s>" + money(reference, cart.currency) + "</s>" : "";
          var deals = "";
          var allocations = item.line_level_discount_allocations || [];
          if (!allocations.length && item.discounts && item.discounts.length) {
            allocations = item.discounts.map(function (deal) {
              return { amount: deal.amount, discount_application: { title: deal.title } };
            });
          }
          allocations.forEach(function (deal) {
            var amount = deal.amount || 0;
            if (amount <= 0) return;
            lineOff += amount;
            var title = (deal.discount_application && deal.discount_application.title) || "Discount";
            deals += '<p class="dshd-deal">' + esc(title) + " – " + money(amount, cart.currency) + "</p>";
          });
          return '<article class="dshd-item">' +
            (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
            '<div>' + variantControl(item, productsByHandle[item.handle]) +
            '<p class="dshd-itemname">' + esc(item.product_title) + '</p>' +
            '<p class="dshd-itemprice">' + money(item.final_line_price, cart.currency) + struck + '</p>' +
            deals +
            '<div class="dshd-itemtools"><div class="dshd-qty">' +
            '<button type="button" data-dshd-qty="-1" data-key="' + esc(item.key) + '">–</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-dshd-qty="1" data-key="' + esc(item.key) + '">+</button>' +
            '</div><button type="button" class="dshd-remove" data-dshd-remove data-key="' + esc(item.key) + '">Remove</button></div></div></article>';
        }).join("");
        var sub = document.querySelector("[data-dshd-subtotal]");
        var total = document.querySelector("[data-dshd-total]");
        var discount = document.querySelector("[data-dshd-discount]");
        var discountRow = document.querySelector("[data-dshd-discountrow]");
        var saved = before - (cart.total_price || 0) - lineOff;
        if (sub) sub.textContent = money(before, cart.currency);
        if (total) total.textContent = money(cart.total_price, cart.currency);
        if (discount && discountRow) {
          discountRow.hidden = saved <= 0;
          discount.textContent = saved > 0 ? "– " + money(saved, cart.currency) : "";
        }
      }

      function getProduct(handle) {
        if (!handle) return Promise.resolve(null);
        if (upsellCache[handle]) return Promise.resolve(upsellCache[handle]);
        return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (product) { if (product) upsellCache[handle] = product; return product; })
          .catch(function () { return null; });
      }

      function getUpsells() {
        if (!upsellHandles.length) return Promise.resolve([]);
        return Promise.all(upsellHandles.map(getProduct));
      }

      function suggestionCards(cart, products) {
        var html = "";
        products.forEach(function (product) {
          if (!product) return;
          if (isBundleItem(product)) return;
          var already = (cart.items || []).some(function (item) { return item.handle === product.handle; });
          if (already) return;
          var variant = firstAvailable(product);
          if (!variant) return;
          var img = product.featured_image || "";
          html += '<div class="dshd-upsell-card">' +
            (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
            '<div><p class="dshd-upsell-name">' + esc(product.title) + '</p>' +
            offerPrice(product, variant, cart.currency) +
            '</div><button type="button" data-dshd-upsell-add data-id="' + variant.id + '">Add</button></div>';
        });
        return html;
      }

      function upgradeCard(cart, product) {
        if (!product) return "";
        var variant = firstAvailable(product);
        if (!variant) return "";
        var img = product.featured_image || "";
        var note = bundleNote ? '<p class="dshd-upsell-note">' + esc(bundleNote) + "</p>" : "";
        return '<div class="dshd-upsell-card dshd-upsell-card--upgrade">' +
          (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
          '<div>' +
          '<p class="dshd-upsell-name">' + esc(product.title) + "</p>" +
          offerPrice(product, variant, cart.currency) +
          note +
          '</div><button type="button" data-dshd-upsell-add data-id="' + variant.id + '">' + esc(bundleCta || "Upgrade") + "</button></div>";
      }

      function resolveBundleProduct(products) {
        if (bundleHandle) {
          var picked = products.filter(function (product) { return product && product.handle === bundleHandle; })[0];
          if (picked) return Promise.resolve(picked);
          return getProduct(bundleHandle);
        }
        var named = products.filter(function (product) { return product && looksLikeBundle(product); })[0];
        return Promise.resolve(named || null);
      }

      function paintUpgrade(cart, products) {
        var box = document.querySelector("[data-dshd-upgrade]");
        if (!box) return Promise.resolve();
        var hasItems = cart.items && cart.items.length;
        if (!hasItems || cartHasBundle(cart)) {
          box.hidden = true;
          box.innerHTML = "";
          return Promise.resolve();
        }
        return resolveBundleProduct(products || []).then(function (product) {
          var html = upgradeCard(cart, product);
          box.hidden = !html;
          box.innerHTML = html;
        });
      }

      function paintUpsell(cart) {
        var box = document.querySelector("[data-dshd-upsell]");
        var emptyBox = document.querySelector("[data-dshd-upsell-empty]");
        var left = threshold - (cart.total_price || 0);
        var hasItems = cart.items && cart.items.length;
        var unlocked = hasItems && left <= 0;
        return getUpsells().then(function (products) {
          return paintUpgrade(cart, products).then(function () {
            if (!upsellHandles.length || unlocked) {
              if (box) { box.hidden = true; box.innerHTML = ""; }
              if (emptyBox && unlocked) emptyBox.innerHTML = "";
              if (!upsellHandles.length && emptyBox) emptyBox.innerHTML = "";
              return;
            }
            var html = suggestionCards(cart, products);
            if (!hasItems) {
              if (box) { box.hidden = true; box.innerHTML = ""; }
              if (emptyBox) emptyBox.innerHTML = html;
              return;
            }
            if (!box) return;
            box.hidden = !html;
            box.innerHTML = html;
          });
        });
      }

      function paint(cart, open) {
        return comparesFor(cart).then(function (pack) {
          render(cart, pack.compares, pack.products);
          return paintUpsell(cart).then(function () {
            if (open) setCart(true);
            return cart;
          });
        });
      }

      function load(open) {
        return fetch("/cart.js", { credentials: "same-origin" })
          .then(function (r) { return r.json(); })
          .then(function (cart) { return paint(cart, open); })
          .catch(function () {});
      }

      function change(key, quantity) {
        return fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: quantity })
        }).then(function (r) { return r.json(); }).then(function (cart) { return paint(cart, false); });
      }

      function lineByKey(key) {
        return ((lastCart && lastCart.items) || []).filter(function (item) { return item.key === key; })[0] || null;
      }

      function swapVariant(key, variantId, select) {
        if (swapping) return;
        var item = lineByKey(key);
        var qty = item ? item.quantity : 1;
        var currentId = item ? String(item.variant_id) : (select && select.getAttribute("data-current"));
        if (String(variantId) === String(currentId)) return;
        swapping = true;
        if (select) select.disabled = true;
        var payload = { id: Number(variantId), quantity: qty };
        if (item && item.properties && Object.keys(item.properties).length) payload.properties = item.properties;
        if (item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
          payload.selling_plan = item.selling_plan_allocation.selling_plan.id;
        }
        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [payload] })
        }).then(function (r) {
          if (!r.ok) throw new Error("add failed");
          return r.json();
        }).then(function () {
          return change(key, 0);
        }).catch(function () {
          if (select) {
            select.disabled = false;
            select.value = currentId;
            var note = select.parentNode.querySelector(".dshd-variant-note");
            if (!note) {
              note = document.createElement("p");
              note.className = "dshd-variant-note";
              select.parentNode.appendChild(note);
            }
            note.textContent = "That option is unavailable.";
          }
          return load(false);
        }).then(function () {
          swapping = false;
        });
      }

      var cartOpen = root.querySelector("[data-dshd-cart-open]");
      if (cartOpen) cartOpen.addEventListener("click", function (event) {
        event.preventDefault();
        load(true);
      });
      document.querySelectorAll("[data-dshd-cart-close]").forEach(function (btn) {
        btn.addEventListener("click", function () { setCart(false); });
      });
      if (body) body.addEventListener("click", function (event) {
        var qty = event.target.closest("[data-dshd-qty]");
        var remove = event.target.closest("[data-dshd-remove]");
        var key = (qty || remove) && (qty || remove).getAttribute("data-key");
        if (!key) return;
        var current = qty ? Number(qty.parentNode.querySelector("span").textContent) : 0;
        var next = remove ? 0 : current + Number(qty.getAttribute("data-dshd-qty"));
        if (next < 0) next = 0;
        change(key, next);
      });
      if (body) body.addEventListener("change", function (event) {
        var select = event.target.closest("[data-dshd-variant]");
        if (!select) return;
        swapVariant(select.getAttribute("data-key"), select.value, select);
      });
      if (layer) layer.addEventListener("click", function (event) {
        var btn = event.target.closest("[data-dshd-upsell-add]");
        if (!btn) return;
        btn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: Number(btn.getAttribute("data-id")), quantity: 1 }] })
        }).then(function () { return load(true); })
          .catch(function () { btn.disabled = false; });
      });
      document.addEventListener("cart:refresh", function () { load(true); });
      window.DsCartOpen = function () { load(true); };
      load(false);
      var spacer = document.querySelector("[data-dshd-spacer]");
      var lastY = window.pageYOffset || 0;
      var pending = false;
      var nextY = lastY;
      function headerHeight() {
        return root.offsetHeight || 98;
      }
      function syncSpacer() {
        if (spacer) spacer.style.height = headerHeight() + "px";
      }
      function readY(event) {
        var node = event && event.target;
        if (node && node !== document && node.nodeType === 1 && node.scrollTop > 0) return node.scrollTop;
        return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      }
      function onScroll() {
        var cartOpenNow = document.querySelector("[data-dshd-cart].is-open");
        var menuOpen = document.querySelector("[data-dshd-drawer]:not([hidden])");
        var y = nextY;
        var dy = y - lastY;
        if (cartOpenNow || menuOpen || y <= 8) root.classList.remove("is-hidden");
        else if (dy > 2 && y > 40) root.classList.add("is-hidden");
        else if (dy < -2) root.classList.remove("is-hidden");
        lastY = y;
      }
      syncSpacer();
      window.addEventListener("resize", syncSpacer);
      document.addEventListener("scroll", function (event) {
        nextY = readY(event);
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          onScroll();
        });
      }, { passive: true, capture: true });
    }

    function boot() {
      document.querySelectorAll("[data-dshd]").forEach(init);
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
    else boot();
    document.addEventListener("shopify:section:load", function (event) {
      var node = event.target && event.target.querySelector("[data-dshd]");
      if (node) init(node);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.dshReady) return;
      root.dataset.dshReady = "true";
      const slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
      if (!slides.length) return;
      let index = 0;
      let timer = null;
      let paused = false;
      const autoplay = root.dataset.autoplay === "true" && slides.length > 1;
      const dots = Array.prototype.slice.call(root.querySelectorAll("[data-dot]"));
      const pauseBtn = root.querySelector("[data-pause]");
      const pauseIcon = root.querySelector("[data-pause-icon]");

      function videoFor(slide) {
        return slide ? slide.querySelector("video") : null;
      }
      function show(next) {
        index = (next + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          const on = i === index;
          slide.classList.toggle("is-on", on);
          const video = videoFor(slide);
          if (!video) return;
          if (on) {
            const play = video.play();
            if (play && play.catch) play.catch(function () {});
          } else {
            video.pause();
          }
        });
        dots.forEach(function (dot, i) { dot.classList.toggle("is-on", i === index); });
      }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      function play() {
        stop();
        if (!autoplay || paused) return;
        timer = setInterval(function () { show(index + 1); }, 6500);
      }
      const prev = root.querySelector("[data-prev]");
      const next = root.querySelector("[data-next]");
      if (prev) prev.addEventListener("click", function () { show(index - 1); play(); });
      if (next) next.addEventListener("click", function () { show(index + 1); play(); });
      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          show(Number(dot.getAttribute("data-dot")) || 0);
          play();
        });
      });
      if (pauseBtn) {
        pauseBtn.addEventListener("click", function () {
          paused = !paused;
          if (pauseIcon) pauseIcon.textContent = paused ? "▶" : "❚❚";
          pauseBtn.setAttribute("aria-label", paused ? "Play" : "Pause");
          if (paused) stop(); else play();
        });
      }
      show(0);
      play();
    }
    function boot(scope) { (scope || document).querySelectorAll("[data-dsh]").forEach(init); }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(document); });
    else boot(document);
    document.addEventListener("shopify:section:load", function (event) { boot(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-showcase-carousel')) {
    customElements.define('image-showcase-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.isc__track');
        this.slides = Array.from(this.querySelectorAll('.isc__slide'));
        this.previous = this.querySelector('.isc__arrow--previous');
        this.next = this.querySelector('.isc__arrow--next');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
        }, options);
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.isc__slide');
          if (slide) this.align(slide, 'auto');
        }, options);
        this.observer = new ResizeObserver(() => {
          this.previous.hidden = this.slides.length < 2;
          this.next.hidden = this.slides.length < 2;
        });
        this.observer.observe(this.track);
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
      }
      align(slide, behavior) {
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const viewport = this.track.getBoundingClientRect();
        const item = slide.getBoundingClientRect();
        this.track.scrollBy({ left: rtl ? item.right - viewport.right : item.left - viewport.left, behavior });
      }
      move(direction) {
        if (!this.slides.length) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        const position = Math.abs(this.track.scrollLeft);
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        if (maximum <= 2) {
          // Keep both arrows useful when all three images fit on desktop.
          if (direction > 0) this.track.append(this.track.firstElementChild);
          else this.track.prepend(this.track.lastElementChild);
          this.slides = Array.from(this.track.children);
        } else if (direction > 0 && position >= maximum - 2) {
          this.track.scrollTo({ left: 0, behavior });
        } else if (direction < 0 && position <= 2) {
          this.track.scrollTo({ left: rtl ? -maximum : maximum, behavior });
        } else {
          const step = this.slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
          this.track.scrollBy({ left: step * direction * (rtl ? -1 : 1), behavior });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
